import React, {useContext, useEffect} from 'react';
import Grid from "@mui/material/Grid";
import CustomSelect from "../../../widgets/inputs/CustomSelect";
import {categoriesV2} from "../../../../utils/dictionaries/Categories";
import {MenuItem, TextField} from "@mui/material";
import CustomMultiText from "../../../widgets/inputs/CustomMultiText";
import {
	bigNoteRegisterNotRequired,
	bigNoteRegisterRequired,
} from "../../../../utils/RegisterUtils";
import {useFormContext} from "react-hook-form";
import { Autocomplete } from '@mui/material';
import {getCategoryByLabel, getSubcategoryByString} from "../../../../utils/GenericUtils";
import {spAslCode} from "../../../../utils/dictionaries/Generics";
import FileInput from "../../carico/utils/FileInput";
import CustomText from "../../../widgets/inputs/CustomText";
import CustomDateInput from "../../../widgets/inputs/CustomDateInput";
import {CategoriesContext} from "../../../../App";
import {PaperComponent} from "../../../../styles/components/DynamicComponentStyle";

export const TicketDetails = ({
	compactFiles = false,
	mail = true,
	noteInputProps = {},
	noteRows = 10,
	ticketSelected,
	tags,
	setTags,
	handleKeyDown,
	inoltra
}) => {
	const {control, errors, watch, register, setValue, reset} = useFormContext();
	const categoriesContext = useContext(CategoriesContext);

	useEffect(() => {
		if (ticketSelected) {
			const categoria = getCategoryByLabel(ticketSelected.categoria,categoriesContext.categoriesV3);
			console.log(ticketSelected.categoria);
			reset({
				...ticketSelected,
				categoria: categoria.label,
				sottoCategoria: getSubcategoryByString(categoria, ticketSelected.sottoCategoria).label
			})
		}
	}, [ticketSelected, setValue, reset,categoriesContext.categoriesV3])

	const handleCreateTag = event => {
		switch (event.key) {
			case ",":
			case "Enter":
			case "\n":
			case "\t":
			case "Alt":
			case "Tab":
			case " ": {
				event.preventDefault();
				event.stopPropagation();
				if (event.target.value.length > 0) {
					setTags([...tags, "#" + event.target.value?.toUpperCase()]);
				}
				break;
			}
			default:
		}
	};

	const noteRules = inoltra ? bigNoteRegisterNotRequired : bigNoteRegisterRequired;
	const noteRegisterRules = noteInputProps?.maxLength
		? {
			...noteRules,
			maxLength: {
				value: noteInputProps.maxLength,
				message: `Massimo ${noteInputProps.maxLength} caratteri`,
			},
		}
		: noteRules;

	return (
		<React.Fragment>
			{/*{*/}
			{/*	!mail &&*/}
			{/*	<React.Fragment>*/}
			{/*		<Grid item xs={12} sm={6}>*/}
			{/*			<CustomText*/}
			{/*				control={control}*/}
			{/*				rules={{required: false}}*/}
			{/*				name={"campoAgg1"}*/}
			{/*				label={"Campo aggiuntivo 1"}*/}
			{/*				autoFocus={false}*/}
			{/*				error={errors["campoAgg1"]}*/}
			{/*			/>*/}
			{/*		</Grid>*/}
			{/*		<Grid item xs={12} sm={6}>*/}
			{/*			<CustomText*/}
			{/*				control={control}*/}
			{/*				rules={{required: false}}*/}
			{/*				name={"campoAgg2"}*/}
			{/*				label={"Campo aggiuntivo 2"}*/}
			{/*				autoFocus={false}*/}
			{/*				error={errors["campoAgg2"]}*/}
			{/*			/>*/}
			{/*		</Grid>*/}
			{/*		<Grid item xs={12} sm={6}>*/}
			{/*			<CustomDateInput*/}
			{/*				name={"dataAgg1"}*/}
			{/*				label={"Data aggiuntiva 1"}*/}
			{/*				control={control}*/}
			{/*				defaultValue={null}*/}
			{/*				rules={{required: false}}*/}
			{/*				error={errors["dataAgg1"]}*/}
			{/*			/>*/}
			{/*		</Grid>*/}
			{/*		<Grid item xs={12} sm={6}>*/}
			{/*			<CustomDateInput*/}
			{/*				name={"dataAgg2"}*/}
			{/*				label={"Data aggiuntiva 2"}*/}
			{/*				control={control}*/}
			{/*				defaultValue={null}*/}
			{/*				rules={{required: false}}*/}
			{/*				error={errors["dataAgg2"]}*/}
			{/*			/>*/}
			{/*		</Grid>*/}
			{/*	</React.Fragment>*/}
			{/*}*/}
			<Grid item xs={12} sm={mail ? 4 : 12}>
				<CustomSelect
					name={"categoria"}
					label={"Seleziona una categoria *"}
					control={control}
					defaultValue={""}
					autoFocus={false}
					none={true}
					noneValue={""}
					rules={{required: true}}
					error={errors["categoria"]}
				>
					{Object.entries(categoriesContext.categoriesV3)
						.sort((a, b) => {
							if (a["1"].label > b["1"].label) return 1;
							if (a["1"].label < b["1"].label) return -1;
							return 0
						})
						.map(([key, val]) => {
							return (
								<MenuItem value={val.label} key={val.label}>
									{val.label}
								</MenuItem>
							);
						})}
				</CustomSelect>
			</Grid>
			{mail &&
				<React.Fragment>
					<Grid item xs={12} sm={2} style={{display: "flex", alignItems: "center"}}>
						<CustomSelect
							name={"sendMail"}
							label={"Invia mail"}
							control={control}
							defaultValue={false}
							autoFocus={false}
							rules={{required: false}}
							error={errors["sendMail"]}
							disabled={watch("email")?.length <= 0}
							tooltip={true}
							title={"Se decidi di inviare la mail il paziente potrà visualizzare ciò che gli è stato riposto, allegare elementi al ticket e rispondere ad esso. NB: La mail deve esistere e deve essere valida!"}
						>
							<MenuItem value={true}>
								Sì
							</MenuItem>
							<MenuItem value={false}>
								No
							</MenuItem>
						</CustomSelect>
					</Grid>
					<Grid item xs={12} sm={2} style={{display: "flex", alignItems: "center"}}>
						<CustomSelect
							name={"contattoMail"}
							label={"Contatto via mail?"}
							control={control}
							defaultValue={false}
							autoFocus={false}
							rules={{required: false}}
							error={errors["contattoMail"]}
							disabled={watch("sendMail") !== true}
							tooltip={true}
							title={"Se al paziente va bene essere contattato via mail (tramite ticket Ocean). NB: La mail deve esistere e deve essere valida e devi spuntare invia mail!"}
						>
							<MenuItem value={true}>
								Sì
							</MenuItem>
							<MenuItem value={false}>
								No
							</MenuItem>
						</CustomSelect>
					</Grid>
					<Grid item xs={4}>
						<CustomSelect
							name={"dst"}
							label={"Asl"}
							control={control}
							defaultValue={""}
							autoFocus={false}
							none={true}
							noneValue={""}
							rules={{required: true}}
							error={errors["dst"]}
						>
							{Object.entries(spAslCode).map(([key, val]) => {
								return (
									<MenuItem value={key} key={key}>
										{val}
									</MenuItem>
								);
							})}
						</CustomSelect>
					</Grid>
				</React.Fragment>
			}
			{
				watch("categoria") && getCategoryByLabel(watch("categoria"),categoriesContext.categoriesV3)?.subCategories?.length > 0 &&
				<Grid item xs={12}>
					<CustomSelect
						name={"sottoCategoria"}
						label={"Quale di queste sotto categorie? *"}
						control={control}
						defaultValue={""}
						autoFocus={false}
						none={true}
						noneValue={""}
						rules={{required: true}}
						error={errors["sottoCategoria"]}
					>
						{getCategoryByLabel(watch("categoria"),categoriesContext.categoriesV3).subCategories.filter(val => val.enabled).map((val, key) => {
							return (
								<MenuItem value={val.label} key={val.label}>
									{val.label}
								</MenuItem>
							);
						})}
					</CustomSelect>
				</Grid>
			}

			<Grid item xs={12}>
				<Autocomplete
					multiple
					freeSolo
					options={[]}
					getOptionLabel={option => option || option}
					value={tags}
					onChange={(event, newValue) => setTags(newValue)}
					filterSelectedOptions
					PaperComponent={PaperComponent}
					renderInput={params => {
						const {inputProps = {}, slotProps = {}, ...textFieldParams} = params;
						return (
							<TextField
								{...textFieldParams}
								margin='dense'
								variant="outlined"
								label="TAG del ticket"
								fullWidth
								slotProps={{
									...slotProps,
									htmlInput: {
										...inputProps,
										...slotProps.htmlInput,
										onKeyDown: handleCreateTag,
									},
								}}
							/>
						);
					}}
				/>
			</Grid>

			<Grid item xs={12} sm={mail ? 7 : 12} style={{marginTop: 10, marginBottom: 20}}>
				<CustomMultiText
					handleKeyDown={handleKeyDown}
					inputRef={register(noteRegisterRules)}
					name={mail ? "dettaglioRichiesta" : "note"}
					label={mail ? "Dettaglio della richiesta *" : "Note*"}
					autoFocus={false}
					error={errors[mail ? "dettaglioRichiesta" : "note"]}
					inputProps={noteInputProps}
					rows={noteRows}
				/>
			</Grid>
			{mail && <Grid item xs={12} sm={5}>
				<CustomMultiText
					handleKeyDown={handleKeyDown}
					inputRef={register(bigNoteRegisterRequired)}
					name={"rispostaOperatore"}
					label={"Risposta operatore*"}
					autoFocus={false}
					error={errors["rispostaOperatore"]}
					rows={10}
				/>
			</Grid>}

			{
				!mail &&
				<Grid item xs={12}>
					<FileInput name={"allegati"} multiple={true} accept={"*"} compact={compactFiles}/>
				</Grid>
			}
		</React.Fragment>
	);
};
